{
  "header": {
    "title": "Inställningar",
    "description": "Hantera dina preferenser, aviseringar och åtkomstinställningar för att anpassa din Chirpee-upplevelse"
  },
  "tabs": {
    "workplace": {
      "title": "Arbetsplats",
      "logo": "Arbetsplatslogotyp",
      "changeLogo": "Byt logotyp",
      "logoEmptyState": "Ingen logotyp uppladdad ännu",
      "logoValidation": {
        "invalidFormat": "Välj en PNG-, JPEG-, GIF- eller WebP-bild.",
        "fileTooLarge": "Bilden får vara högst 5 MB.",
        "dimensionsTooLarge": "Bilden får vara högst 4096 × 4096 pixlar.",
        "loadFailed": "Bilden kunde inte läsas. Prova en annan fil."
      },
      "logoUploadErrorFallback": "Logotypen kunde inte laddas upp. Försök igen.",
      "maxSize": "Max. 5 MB · max. 4096 × 4096 px",
      "format": "PNG, JPEG, GIF eller WebP",
      "worplaceNameInput": {
        "label": "Arbetsplatsens namn",
        "placeholder": "Arbetsplatsens namn"
      },
      "companyIndustryInput": {
        "label": "Bransch",
        "placeholder": "Företagets bransch",
        "industries": {
          "technology": "Teknik",
          "professionalServices": "Professionella tjänster",
          "financialServices": "Finansiella tjänster",
          "consulting": "Konsultverksamhet",
          "softwareDevelopment": "Mjukvaruutveckling",
          "digitalMarketing": "Digital marknadsföring",
          "mediaAndCommunications": "Media och kommunikation",
          "eCommerce": "E-handel",
          "healthTech": "Hälsoteknik"
        }
      },
      "languguages": {
        "title": "Tillgängliga språk",
        "helpText": "Hjälptext"
      },
      "applyButton": "Tillämpa ändringar"
    },
    "userManagement": {
      "title": "Användarhantering",
      "userInput": {
        "placeholder": "Sök användare"
      },
      "roleDropdown": {
        "triggerLabel": "Roll",
        "options": {
          "admin": "Administratör",
          "people_experience": "Personalupplevelse",
          "user": "Användare"
        }
      }
    },
    "integrations": {
      "title": "Integrationer",
      "options": {
        "hris": { "label": "HRIS" },
        "sso": { "label": "Single Sign-On (SSO)" },
        "messagingConnected": { "label": "Kommunikationsverktyg" }
      }
    },
    "billing": {
      "title": "Fakturering",
      "planSection": {
        "title": "Ditt abonnemang",
        "status": {
          "active": "Aktivt"
        },
        "usersCount": {
          "title": "Månadsanvändare"
        },
        "amount": {
          "title": "Förnyelsebelopp",
          "cost": "per användare"
        },
        "charge": {
          "title": "Nästa debitering"
        },
        "cycle": {
          "title": "Faktureringsperiod"
        }
      },
      "invoiceInformationSection": {
        "title": "Faktureringsinformation",
        "name": "Företagsnamn",
        "email": "Faktura-e-post",
        "address": "Företagsadress",
        "taxId": "Skatte-ID",
        "paymentMethod": "Betalningsmetod",
        "paymentDate": "Senaste betalningsdatum",
        "editButton": "Redigera",
        "portalError": "Det gick inte att öppna faktureringsportalen. Försök igen."
      },
      "invoiceHistorySection": {
        "title": "Fakturahistorik",
        "viewButton": "Visa",
        "downloadButton": "Ladda ner",
        "emptyState": {
          "title": "Inga fakturor ännu",
          "description": "Fakturor visas här efter din första lyckade betalning."
        }
      },
      "errorState": {
        "title": "Det gick inte att ladda faktureringsinformation",
        "description": "Uppdatera sidan och försök igen."
      }
    },
    "logs": {
      "title": "Granskningsloggar",
      "table": {
        "title": "Senaste aktivitet",
        "acitivityDropdown": {
          "triggerLabel": "Alla aktiviteter"
        },
        "usersDropdown": {
          "triggerLabel": "Alla användare"
        },
        "exportButton": "Exportera loggar"
      }
    }
  }
}
